import BaseClient from '@/app/model/api/response/baseApiClient'

class ConstantValueApi extends BaseClient {
  public getConstantValue () {
    const path = '/v1/constant/value'
    var url = new URL(process.env.VUE_APP_API_URL + path)
    var params = new URLSearchParams({})

    /* 共通処理 */
    return super.doFetch(process.env.VUE_APP_API_URL + path, 'GET')
  }
}

export default new ConstantValueApi()
